import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sectors',
    templateUrl: './sectors.component.html',
    styleUrls: ['./sectors.component.scss']
})

export class DashboardSectorsComponent implements OnInit {
    constructor() { }

    ngOnInit() {
    }
}
